module.exports = __webpack_public_path__ + "static/img/douyin-qrcode1.6b8aa4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/douyin-qrcode1.jpg
// module id = Z2jI
// module chunks = 68